module.exports = __webpack_public_path__ + "img/tjx_d_22.790990a5.png";